import React, { forwardRef, useImperativeHandle } from "react";
import Toggle from "../../../button/Toggle";
import { useForm } from "react-hook-form";
import { get } from "js-cookie";

export const Bond = forwardRef(({ bond, onSubmitBond }, ref) => {
  const { formState, control, handleSubmit, getValues } = useForm();
  const getFormErrorMessage = (name) => {
    return formState.errors[name] ? (
      <small className="p-error">{formState.errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  useImperativeHandle(ref, () => ({
    submit: () => handleSubmit(onSubmitBond)(),
    getValues: () => getValues(),
  }));

  return (
    <>
      <div className="col-md-12 mt-3 mb-2">
        <div className="inline-flex align-items-center">
          <i className="fa-solid fa-retweet me-2"></i>
          <b>Vinculos</b>
        </div>
      </div>

      <div className="container">
        <div className="row ">
          {bond?.map((item, index) => (
            <div key={index} className="col-md-4 mb-3">
              <Toggle
                offLabel={item.accessible}
                onLabel={item.accessible}
                name={`bond_id-${item.id}`}
                control={control}
                type="text"
                id={`accessible-${item.id}`}
                className="form-control"
                value={item.id}
                preValue={true}
                readOnly
                getFormErrorMessage={getFormErrorMessage}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
});
